import { render, staticRenderFns } from "./PatientSwiper.vue?vue&type=template&id=624243f6&scoped=true&"
import script from "./PatientSwiper.vue?vue&type=script&lang=js&"
export * from "./PatientSwiper.vue?vue&type=script&lang=js&"
import style0 from "./PatientSwiper.vue?vue&type=style&index=0&id=624243f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624243f6",
  null
  
)

export default component.exports